var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2274)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_2274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52 1C2.38 1 2.25 1.06 2.15 1.15C2.05 1.25 2 1.38 2 1.52V17.15C2 17.29 2.06 17.42 2.15 17.52C2.25 17.62 2.38 17.67 2.52 17.67H7.9V8.06C7.9 7.97 7.94 7.88 8 7.81C8.06 7.74 8.15 7.71 8.25 7.71H14.75V1.52C14.75 1.38 14.69 1.25 14.6 1.15C14.5 1.05 14.37 1 14.23 1H2.52ZM7.62 14.25H3.51V13.2H7.62V14.25ZM7.62 11.89H3.43V10.84H7.61V11.89H7.62ZM7.62 9.52H3.51V8.47H7.62V9.52ZM13.24 7.15H3.51V6.1H13.24V7.15ZM13.24 4.79H4.49V3.74H13.24V4.79Z",
    fill: "#97D5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.24 3.73999H4.48999V4.78999H13.24V3.73999Z",
    fill: "#5A6E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.24 6.10999H3.51001V7.15999H13.24V6.10999Z",
    fill: "#5A6E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62001 8.46997H3.51001V9.51997H7.62001V8.46997Z",
    fill: "#5A6E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60999 10.84H3.42999V11.89H7.60999V10.84Z",
    fill: "#5A6E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62001 13.21H3.51001V14.26H7.62001V13.21Z",
    fill: "#5A6E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60001 23.35H19.6V8.41003H8.60001V23.34V23.35ZM10.22 10.28H18.97V11.33H10.22V10.28ZM9.23001 12.65H18.96V13.7H9.23001V12.65ZM9.23001 15.01H18.96V16.06H9.23001V15.01ZM9.23001 17.38H18.96V18.43H9.23001V17.38ZM9.23001 19.75H16.54V20.8H9.23001V19.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.70996H8.24999C8.15999 7.70996 8.06999 7.74996 7.99999 7.80996C7.93999 7.86996 7.89999 7.95996 7.89999 8.05996V23.69C7.89999 23.78 7.93999 23.87 7.99999 23.94C8.05999 24.01 8.14999 24.04 8.24999 24.04H19.95C20.04 24.04 20.13 24 20.2 23.94C20.26 23.88 20.3 23.79 20.3 23.69V8.05996C20.3 7.96996 20.26 7.87996 20.2 7.80996C20.13 7.73996 20.04 7.70996 19.95 7.70996H14.75ZM19.6 23.35H8.59999V8.40996H19.6V23.34V23.35Z",
    fill: "#5A6E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.97 10.28H10.22V11.33H18.97V10.28Z",
    fill: "#5CBFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.96 12.65H9.23001V13.7H18.96V12.65Z",
    fill: "#5CBFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.96 15.01H9.23001V16.06H18.96V15.01Z",
    fill: "#5CBFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.96 17.38H9.23001V18.43H18.96V17.38Z",
    fill: "#5CBFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.54 19.75H9.23001V20.8H16.54V19.75Z",
    fill: "#5CBFAB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_2274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3,
    height: 23.04,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.f47cc0126233000fd89bd32628c4a5dd.svg";
export { ForwardRef as ReactComponent };